import { constants } from "../../constants";
export const metaDataAction = (data) => {
    return {type: constants.IS_META, payload: data};
};
